import wx from 'weixin-js-sdk'; // 微信sdk依赖
import { ShareSign } from "@/http/api";
// 引用全局
/* eslint-disable */
const jsApiList = [
	'checkJsApi',
	'onMenuShareTimeline',
	'onMenuShareAppMessage',
	'hideOptionMenu',
	'showOptionMenu',
	//   'shareTimeline' //不存在
];
// 要用到微信API
 async function  getJSSDK(dataForWeixin) {
 		console.log(dataForWeixin)
		let param = {
			pay_type: 'member',
			// member
			amount: 0
		}
		let chars='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
		let nonceStr=''
		for(var i=0;i<5;i++){
			nonceStr+=chars.charAt(Math.floor(Math.random() * 62))
		}
	
			let param2=JSON.stringify({
				timestamp:Math.floor((new Date().getTime())/1000), // 必填，生成签名的时间戳
				noncestr: nonceStr, // 必填，生成签名的随机串
				url:location.href.split('#')[0]
			})
			console.log('param2',param2)
			ShareSign(param2).then(res=>{
				console.log('2',res)
				 let data=res.data
					console.log('分享签名',res)
					wx.config({
								debug:false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
								appId:localStorage['site_current_app_id']?localStorage['site_current_app_id']:'wx65cb2c350a5f35f3', // 必填，公众号的唯一标识
								// appId:'wx4b41153d6a5e9f20',
								timestamp:data.timestamp, // 必填，生成签名的时间戳
								nonceStr: data.noncestr, // 必填，生成签名的随机串
								signature:data.sign, // 必填，签名
								jsApiList:['onMenuShareAppMessage','onMenuShareTimeline','onMenuShareQQ','onMenuShareWeibo'], //'updateAppMessageShareData','updateTimelineShareData' 必填，需要使用的JS接口列表
							});
			wx.ready(() => {
			wx.onMenuShareAppMessage({
				title: dataForWeixin.title,
				desc: dataForWeixin.desc,
				link: dataForWeixin.linkurl,
				imgUrl: dataForWeixin.img,
				trigger: function trigger(res) { },
				success: function success(res) {
					console.log('已分享');
				},
				cancel: function cancel(res) {
					console.log('已取消');
				},
				fail: function fail(res) {
					console.log(JSON.stringify(res), 123456);
				},
			});
			// 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
			wx.onMenuShareTimeline({
				title: dataForWeixin.title,
				link: dataForWeixin.linkurl,
				imgUrl: dataForWeixin.img,
				trigger: function trigger(res) {
					// alert('用户点击分享到朋友圈');
				},
				success: function success(res) {
					// alert('已分享');
				},
				cancel: function cancel(res) {
					// alert('已取消');
				},
				fail: function fail(res) {
					alert(JSON.stringify(res));
				},
			});
			// 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
			wx.onMenuShareQQ({
				title: dataForWeixin.title,
				desc: dataForWeixin.desc,
				link: dataForWeixin.linkurl,
				imgUrl: dataForWeixin.img,
				trigger: function trigger(res) {
					// alert('用户点击分享到QQ');
				},
				complete: function complete(res) {
					alert(JSON.stringify(res));
				},
				success: function success(res) {
					// alert('已分享');
				},
				cancel: function cancel(res) {
					// alert('已取消');
				},
				fail: function fail(res) {
					// alert(JSON.stringify(res));
				},
			});
			// 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
			wx.onMenuShareWeibo({
				title: dataForWeixin.title,
				desc: dataForWeixin.desc,
				link: dataForWeixin.linkurl,
				imgUrl: dataForWeixin.img,
				trigger: function trigger(res) {
					// alert('用户点击分享到微博');
				},
				complete: function complete(res) {
					// alert(JSON.stringify(res));
				},
				success: function success(res) {
					// alert('已分享');
				},
				cancel: function cancel(res) {
					// alert('已取消');
				},
				fail: function fail(res) {
					// alert(JSON.stringify(res));
					console.log(JSON.stringify(res));
				},
			});
		});
		// wx.error((res) => {
		// 	// console.log(`${JSON.stringify(res)}微信验证失败`, 456);
		// 	alert(JSON.stringify(res)+"微信验证失败");
		// });
	})	
}
export default {
	// 获取JSSDK
	getJSSDK,
};